export class APIError extends Error {
    constructor(public status: number, public data: any) {
        super(`API Error: ${status}`);
    }
}

// Use environment variable for API URL, fallback to relative path for local dev
const BASE_URL = import.meta.env.VITE_API_URL || '';

export const api = {
    async get<T>(endpoint: string): Promise<T> {
        const res = await fetch(`${BASE_URL}${endpoint}`, {
            credentials: 'include', // Include cookies for cross-domain
        });
        if (!res.ok) {
            throw new APIError(res.status, await res.json().catch(() => ({})));
        }
        const json = await res.json();
        return json.data ?? json; // Handle standard API response wrapper { success: true, data: ... }
    },

    async post<T>(endpoint: string, body: any): Promise<T> {
        const res = await fetch(`${BASE_URL}${endpoint}`, {
            method: 'POST',
            credentials: 'include', // Include cookies for cross-domain
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
        });
        if (!res.ok) {
            throw new APIError(res.status, await res.json().catch(() => ({})));
        }
        const json = await res.json();
        return json.data ?? json;
    },

    // Add put, delete etc if needed
};
